type ApplicationBootstrapInput = {
  loading: boolean;
  hasOrganization: boolean;
  organizationOnboardingResolved: boolean;
};

/**
 * The application shell must not render until a workspace's onboarding
 * decision is known. Keeping this invariant outside React makes it harder for
 * future context refactors to reintroduce the dashboard-before-onboarding
 * flash.
 */
export function isApplicationBootstrapPending({
  loading,
  hasOrganization,
  organizationOnboardingResolved,
}: ApplicationBootstrapInput): boolean {
  return loading || (hasOrganization && !organizationOnboardingResolved);
}

